import { useState } from 'react';
import { IconButton, Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ExpandLessIcon, ExpandMoreIcon } from '../../assets';

/** Bordered, collapsible section used for the logs on Activity tabs. */
export function ActivitySectionCard({
  title,
  actions,
  children,
}: {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}) {
  const { classes } = useStyles();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Paper variant='outlined' sx={{ p: '16px 18px', mb: 3 }}>
      <div className={classes.header}>
        <h2 className={classes.title}>{title}</h2>
        <div className={classes.actions}>
          {actions}
          <IconButton
            onClick={() => setIsOpen((v) => !v)}
            size='small'
            aria-expanded={isOpen}
            aria-label={`${isOpen ? 'Collapse' : 'Expand'} ${title}`}
          >
            {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
      </div>
      <div style={{ display: isOpen ? 'block' : 'none' }}>{children}</div>
    </Paper>
  );
}

const useStyles = makeStyles({ name: { ActivitySectionCard } })(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  title: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0,
    margin: 0,
  },
}));
